// react
import { useMemo } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { Link } from '@tanstack/react-router';

// material ui
import { DataGrid, GridRow } from '@mui/x-data-grid';

// shared components
import { DataGridToolbar } from '@/components/ui/datagrid/DataGridToolbar';

const UtilityProviderDatagrid = ({ providers = [], utilityType }) => {
  const { t } = useTranslation('portfolio-analysis');

  function LinkRow(props) {
    const rowProviderId = props.row?.provider_id;
    return (
      <Link
        to={`/$accountId/operations/portfolio-analysis/utility-providers/${utilityType}/${rowProviderId}`}
        style={{
          display: 'contents',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <GridRow {...props} />
      </Link>
    );
  }

  const columns = useMemo(
    () => [
      {
        field: 'provider_id',
        headerName: t('utilityProviderPage.datagrid.columns.providerId'),
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'provider_name',
        headerName: t('utilityProviderPage.datagrid.columns.providerName'),
        flex: 2,
        minWidth: 200,
      },
    ],
    [t],
  );

  return (
    <DataGrid
      rows={providers || []}
      columns={columns}
      getRowId={(row) => row.provider_id}
      pageSizeOptions={[10, 25, 50, 100]}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
      disableRowSelectionOnClick
      showToolbar
      slots={{
        toolbar: DataGridToolbar,
        row: LinkRow,
      }}
      slotProps={{
        toolbar: {
          showDivider: false,
        },
      }}
    />
  );
};

export default UtilityProviderDatagrid;
